import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-d-flex p-flex-column p-flex-md-row" }
const _hoisted_2 = { class: "p-d-flex p-flex-column p-flex-md-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Menubar = _resolveComponent("Menubar")!

  return (_ctx.isReady)
    ? (_openBlock(), _createBlock(_component_Menubar, {
        key: 0,
        model: _ctx.items,
        class: "p-d-flex p-jc-end",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$store.state.menubarClicked=true))
      }, {
        start: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_Button, {
              label: _ctx.$t('app_name'),
              class: "p-button-text p-mb-2 p-mr-4",
              icon: "pi pi-home",
              style: {"color":"black"},
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToRoute('Home')))
            }, null, 8, ["label"])
          ])
        ]),
        item: _withCtx(({item}) => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Button, {
              icon: item.icon,
              label: _ctx.$t(item.label),
              class: "p-button-text p-mb-2 p-mr-4",
              style: {"color":"black"},
              onClick: ($event: any) => (_ctx.goToRoute(item.route))
            }, null, 8, ["icon", "label", "onClick"])
          ])
        ]),
        end: _withCtx(() => [
          _createVNode(_component_Dropdown, {
            class: "p-dropdown-sm",
            options: _ctx.LOCALES,
            optionLabel: "value",
            placeholder: _ctx.$store.state.language,
            onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateLanguage($event)))
          }, null, 8, ["options", "placeholder"])
        ]),
        _: 1
      }, 8, ["model"]))
    : _createCommentVNode("", true)
}